import { useEffect } from 'react';

/**
 * Custom hook to set page title dynamically
 * @param {string} pageTitle - The title of the current page (e.g., "Students", "Dashboard")
 */
export const usePageTitle = (pageTitle) => {
  useEffect(() => {
    const baseTitle = 'EMP Medic | Portal';
    
    if (pageTitle) {
      document.title = `${pageTitle} | ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }
    
    // Cleanup - reset to base title when component unmounts
    return () => {
      document.title = baseTitle;
    };
  }, [pageTitle]);
};

export default usePageTitle;
